import en from '@config/i18n/en.json';
import ru from '@config/i18n/ru.json';
import type {Language} from '@interfaces/i18n';
import type ValueList from '@interfaces/ValueList';
import {ProductType} from "@constants/productType";

const RU = 'ru';
const EN = 'en';

let currentLanguage: Language;

export function setCurrentLanguage(language: Language) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!language) {
        currentLanguage = RU;
        return;
    }
    currentLanguage = language;
}

export function getCurrentLanguage(): Language {
    return currentLanguage;
}

export function getLocalizedLine(code: string): string {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!currentLanguage) {
        throw new Error(
            'current language not set. Please, set it with setCurrentLanguage() before using i18n capabilities',
        );
    }

    const dict = getDict(currentLanguage);
    return dict[code] || code;
}

export function getVpnLocalizedLine(code: string, product?: string): string {
    if (!currentLanguage) {
        throw new Error(
            'current language not set. Please, set it with setCurrentLanguage() before using i18n capabilities',
        );
    }

    const dict = getDict(currentLanguage);
    const fullCode = `${product}.${code}`;
    return dict[fullCode] || dict[`${ProductType.Vpn}.${code}`] || fullCode;
}

function getDict(language: string): ValueList<string> {
    switch (language) {
        case RU:
            return ru;
        case EN:
            return en;
        default:
            throw new Error('unknown language');
    }
}
